import { FC, PropsWithChildren } from 'react'

import styled from 'styled-components'

import { colors, device } from 'src/Helpers/constants'

export type PageTitleProps = PropsWithChildren

const StyledPageTitle = styled.h2`
  font-size: 32px;
  font-weight: 800;
  margin: 0;
  text-transform: uppercase;
  color: ${colors.thirdGray};

  @media ${device.tabletMax} {
    font-size: 25px;
    text-align: start;
    text-transform: none;
  }
`

export const PageTitle: FC<PageTitleProps> = ({ children }) => {
  return <StyledPageTitle>{children}</StyledPageTitle>
}
